import * as R from 'ramda'
import React, { useContext, useRef } from 'react'
import Select from 'react-select'
import { ThemeContext } from 'styled-components'

const customStyles = color => ({
  control: (styles, { isFocused, isSelected }) => ({
    position: 'relative',
    display: 'flex',
    backgroundColor: '#fff',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: isFocused ? color.theme : color.lightGrey,
    borderRadius: '4px',
    cursor: 'pointer',
    minWidth: '64px',
    height: '30px',
    ':hover': {
      borderColor: color.theme
    }
  }),
  option: (styles, { isFocused, isSelected }) => ({
    height: '30px',
    padding: '8px 16px',
    backgroundColor: isSelected ? color.pink : '#fff',
    color: color.grey,
    ':hover': {
      backgroundColor: color.lightGrey
    },
    ':active': {
      backgroundColor: color.pink
    },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer'
  }),
  valueContainer: styles => ({
    width: '100%',
    padding: '0 8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }),
  menu: styles => ({
    ...styles,
    width: '100%',
    border: `1px solid ${color.theme}`,
    borderRadius: '4px',
    zIndex: '3',
    backgroundColor: '#fff',
    marginTop: '4px',
    marginBottom: '4px'
  }),
  indicatorSeparator: styles => ({
    display: 'none'
  })
})

export default React.memo(({ options, value, onChange, ...props }) => {
  const { color } = useContext(ThemeContext)
  const selectRef = useRef()
  const handleChange = selected => {
    onChange(selected.value)
    selectRef.current.blur()
  }
  const getOptByVal = R.find(R.propEq('value', value))(options)
  return (
    <Select
      // https://github.com/JedWatson/react-select/issues/2629
      instanceId='heart'
      isSearchable={false}
      options={options}
      onChange={handleChange}
      value={getOptByVal}
      styles={customStyles(color)}
      ref={selectRef}
      menuPlacement='auto'
    />
  )
})
